import {
  ADD_CONTRACTOR_FAIL,
  ADD_CONTRACTOR_SUCCESS,
  ADD_SERVICE_FAIL,
  ADD_SERVICE_SUCCESS,
  ADD_VISITOR_FAIL,
  ADD_VISITOR_SUCCESS,
  CONTRACTOR_LIST_FAIL,
  CONTRACTOR_LIST_SUCCESS,
  CONTRACTOR_STATUS_FAIL,
  CONTRACTOR_STATUS_SUCCESS,
  REMOVE_VISITOR_FILE_FAIL,
  REMOVE_VISITOR_FILE_SUCCESS,
  SERVICE_LIST_FAIL,
  SERVICE_LIST_SUCCESS,
  UPDATE_CONTRACTOR_FAIL,
  UPDATE_CONTRACTOR_SUCCESS,
  UPDATE_LOCATION_FAIL,
  UPDATE_LOCATION_SUCCESS,
  UPDATE_SERVICE_FAIL,
  UPDATE_SERVICE_SUCCESS,
  UPDATE_VISITOR_FAIL,
  UPDATE_VISITOR_SUCCESS,
  VISITOR_LIST_FAIL,
  VISITOR_LIST_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  res: {},
  error: {},
  list: [],
  pageCount: 0,
  pageSize: 20,
  pageIndex: 1,
  totalRecords: 0,
  serviceList: [],
  contractorList: [],
};

const Location = (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_LOCATION_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case UPDATE_LOCATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_SERVICE_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case UPDATE_SERVICE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_CONTRACTOR_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case UPDATE_CONTRACTOR_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case CONTRACTOR_STATUS_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case CONTRACTOR_STATUS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case REMOVE_VISITOR_FILE_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case REMOVE_VISITOR_FILE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_VISITOR_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case UPDATE_VISITOR_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_CONTRACTOR_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case ADD_CONTRACTOR_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case CONTRACTOR_LIST_SUCCESS:
      return {
        ...state,
        contractorList: action.payload,
      };
    case CONTRACTOR_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_SERVICE_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case ADD_SERVICE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SERVICE_LIST_SUCCESS:
      return {
        ...state,
        serviceList: action.payload,
      };
    case SERVICE_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case VISITOR_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload?.data?.value || [],
        pageCount: action.payload?.data?.pagination?.total_pages,
        pageSize: action.payload?.data?.pagination?.limit,
        pageIndex: (action.payload?.data?.pagination?.current_page || 1) - 1,
        totalRecords: action.payload?.data?.pagination?.total_records,
      };
    case VISITOR_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_VISITOR_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case ADD_VISITOR_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default Location;
